
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const DevelopmentBanner = () => {
  const { t } = useTranslation();
  
  return (
    <div className="w-full p-4 bg-primary/5 border border-primary/10 rounded-lg">
      <div className="flex items-center gap-2">
        <AlertCircle className="w-5 h-5 text-primary" />
        <p className="text-sm">
          <span className="font-semibold">{t('development_banner_highlight')}</span>
          {" "}{t('development_banner_message')}
        </p>
      </div>
    </div>
  );
};
